import { Hatch, HatchMap } from "../classes/Hatch.js";

export default class Code {
  props: {
    maxLines: number;
    content: string;
    lines: number;
    el: HTMLElement;
  };

  constructor(el: HTMLElement) {
    this.props = {
      maxLines: parseInt(el.getAttribute("data-code-lines")),
      content: el.getAttribute("data-code-content"),
      lines: el.getAttribute("data-code-content").split("\n").length,
      el: el,
    };
    let template = `
      ${HatchMap(
        this.props.content.split("\n"),
        (line: string, index: number) => Hatch`
      <div class="code-block__line ${index + 1 > this.props.maxLines ? "hidden" : ""}">
        <div class="code-block__line__number">${index + 1}</div>
        <div class="code-block__line__content">${Hatch`${line}`}</div>
      </div>
      `
      )}
    `;
    this.props.el.innerHTML = template;

    if (this.props.lines > this.props.maxLines) {
      this.initCollapser();
    }
  }

  initCollapser() {
    let expandEl = document.createElement("div");
    expandEl.classList.add("code-block__expand");
    expandEl.innerHTML = Hatch`
      <button>Click to expand</button>
    `.toString();
    this.props.el.appendChild(expandEl);
    expandEl.addEventListener("click", () => {
      this.toggleExpand();
    });
  }

  toggleExpand() {
    if (this.props.el.getAttribute("data-expanded") === "true") {
      this.props.el.setAttribute("data-expanded", "false");
      this.props.el.querySelector<HTMLElement>(".code-block__expand button").innerText = "Click to expand";
      this.props.el.querySelectorAll(".code-block__line").forEach((item, index) => {
        if (index + 1 > this.props.maxLines) item.classList.add("hidden");
      });
    } else {
      this.props.el.setAttribute("data-expanded", "true");
      this.props.el.querySelector<HTMLElement>(".code-block__expand button").innerText = "Click to shrink";
      this.props.el.querySelectorAll(".code-block__line").forEach((item) => {
        item.classList.remove("hidden");
      });
    }
  }
}
